import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: "https://fe8965cb7f71f51ded9a2e951a054b1d@o141269.ingest.us.sentry.io/4509718266576896",
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  sendDefaultPii: true,
  tracesSampleRate: 0.1,
});

ReactDOM.render(
  <App/>
  ,
  document.getElementById('react-autoipacket-document-viewer')
);
